export interface FareDrawerLayout {
  collapsedSnapPoint: number
  expandedSnapPoint: number
  collapsedHeight: number
  expandedHeight: number
}

export function getFareDrawerLayout(
  viewportHeight: number = window.innerHeight
): FareDrawerLayout {
  const safeViewportHeight = viewportHeight > 0 ? viewportHeight : 844
  const collapsedSnapPoint = 0.45
  const expandedSnapPoint = 0.96

  return {
    collapsedSnapPoint,
    expandedSnapPoint,
    collapsedHeight: Math.round(safeViewportHeight * collapsedSnapPoint),
    expandedHeight: Math.round(safeViewportHeight * expandedSnapPoint),
  }
}
